import { Component, Optional, Inject } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { UntypedFormBuilder } from '@angular/forms';
import { RegistrationModel } from '../../models/registration.model';
import { TnRIncidentService } from '../../services/title-registration-incident.service';
import { IncidentTypeService } from '../../services/incident-type.service';
import { IncidentDialogContext } from '../../shared/incident-dialog-context.model';
import { IncidentModalComponent } from '../../incident-modal.component';
import { IncidentService } from '../../services/incident.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../../shared/services/modal/mvd-modal.service';
import { ProhibitionService } from '../../../prohibition/services/prohibition.service';
import { EnumDataService } from '@max/incident/services/enums.DataService';

@Component({
    templateUrl: './fr-accident-modal.html'
})

export class FrAccidentModalComponent extends IncidentModalComponent<RegistrationModel> {
    constructor(
        public dialogRef: MatDialogRef<IncidentModalComponent<RegistrationModel>>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: IncidentDialogContext<RegistrationModel>,
        public incidentService: IncidentService,
        public prohibitionService: ProhibitionService,
        private service: TnRIncidentService,
        location: PlatformLocation,
        fb: UntypedFormBuilder,
        typeService: IncidentTypeService,
        modalService: MvdModalService,
        EnumDataService: EnumDataService
    ) {
        super(data, prohibitionService, fb, dialogRef, modalService, incidentService, EnumDataService, typeService, location);

        this.service = service;
    }

    protected onLoadIncident(callback: (error?) => void): void {
        this.service.getIncident(this.data.incident.incidentNumberId).subscribe(r => this.onGetIncidentCompleted(r, callback), e => callback(e));
    }

    private onGetIncidentCompleted(incident: RegistrationModel, callback: (error?) => void): void {
        this.data.incident = incident;

        this.showUserInput = true;
        callback();
    }

    protected onSaveIncident(callback: (error?: any) => void): void {
        this.service.saveIncident(this.data.incident).subscribe(r => { }, callback, callback);
    }

    protected onDeleteIncident(callback: () => void): void {
        this.service.deleteIncident(this.data.incident.incidentNumberId)
            .subscribe(_ => { }, e => this.handleError, () => {
                this.dialogRef.close(true);
            });
    }
}
